var autocomplete = [];

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        var inputFields = document.querySelectorAll(".moving-location");
        if (inputFields) {
            addMapScriptsToPage();
        }
    });
}
else {
    var inputFields = document.querySelectorAll(".moving-location");
    if (inputFields) {
        addMapScriptsToPage();
    }
}

async function addMapScriptsToPage() {
    var scriptPlaceholder = document.querySelector("#gmaps-script");
    if (scriptPlaceholder && scriptPlaceholder.dataset.apiUrl) {
        if (typeof (google) !== "undefined" && google && google.maps) {
            scriptPlaceholder.remove();
        }
        else {
            var scriptTag = document.createElement("script");
            scriptTag.async = true;
            scriptTag.src = scriptPlaceholder.dataset.apiUrl;
            scriptTag.type = "text/javascript";
            document.body.insertAdjacentElement("beforeend", scriptTag);
            scriptPlaceholder.remove();

            if (typeof (google) === "undefined" || !google || !google.maps) {
                await new Promise((resolve, reject) => {
                    scriptTag.addEventListener('load', resolve, { once: true });
                    scriptTag.addEventListener('error', reject, { once: true });
                });
            }
        }
        //Google places search init (moving from/moving to auto-complete)
        //initPlaces();
    }
}

function initPlaces() {

    var inputFields = document.querySelectorAll(".moving-location");
    if (!inputFields)
        return;

    for (var index = 0; index < inputFields.length; index++) {
        var locationInput = inputFields[index];
        if (!autocomplete[locationInput.id]) {
            autocomplete[locationInput.id] = new google.maps.places.Autocomplete(locationInput);
            //Just cities: autocomplete[locationInput.id].setTypes(['(cities)']);
            locationInput.addEventListener("focus", function(evt) {
                //if (!$(this).hasClass("international-input")) {
                if ((document.querySelector('#destination_international')?.checked || this.classList.contains("international-input")) && evt.target.id ==='MovingTo'){
                    autocomplete[this.id].setComponentRestrictions({ country: [] });  
                } else {
                    var countryCode = document.querySelector('[name="CountryCode"]').value;
                    autocomplete[this.id].setComponentRestrictions({
                        country: [countryCode],
                    });
                }
            })
            
            setupAutoCompleteListner(
                locationInput.id,
                autocomplete[locationInput.id]
            );
            setupOnChangeListner(locationInput);
        }

        //disable submission on "enter"
        locationInput.addEventListener("keydown", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    }


    function setupAutoCompleteListner(id, autocomplete) {
        autocomplete.addListener("place_changed", function () {
            var components = this.getPlace().address_components;
            //var $wrap = locationInput.closest("fieldset");
            var $addr1 = document.querySelector("#" + id + "AddressFields_AddressLine1"),
                $city = document.querySelector("#" + id + "AddressFields_City"),
                $state = document.querySelector("#" + id + "AddressFields_State"),
                $zip = document.querySelector("#" + id + "AddressFields_ZipCode"),
                $country = document.querySelector("#" + id + "AddressFields_Country");

            //Clear all fields first so it removes previously selected address.
            $addr1.value="";
            $city.value="";
            $state.value="";
            $zip.value="";
            $country.value="";

            //alert($addr1.attr("id") + $city.attr("id"));

            var streetNumber, route, sep, comp;

            if (!components) {
                console.log("components error: ");
                console.log(components);
                return;
            }

            for (var c = 0; c < components.length; ++c) {
                comp = components[c];

                if (comp.types.indexOf("street_number") > -1) {
                    streetNumber = comp.long_name;
                }
                if (comp.types.indexOf("route") > -1) {
                    route = comp.short_name;
                }
                if (comp.types.indexOf("locality") > -1) {
                    $city.value=comp.long_name;
                } else if (comp.types.indexOf("postal_town") > -1 && (!$city.value || $city.value.trim() === '')) {
                    $city.value=comp.long_name;
                } else if (comp.types.indexOf("administrative_area_level_2") > -1 && (!$city.value || $city.value.trim() === '')) {
                    $city.value=comp.long_name;
                }
                if (
                    comp.types.indexOf("administrative_area_level_1") > -1 &&
                    comp.types.indexOf("political") > -1
                ) {
                    $state.value=comp.short_name;
                }
                if (comp.types.indexOf("postal_code") > -1) {
                    $zip.value=comp.short_name;
                }
                if (comp.types.indexOf("country") > -1) {
                    $country.value=comp.short_name;
                }
            }

            sep = streetNumber && route ? " " : "";

            streetNumber = streetNumber || "";
            route = route || "";

            $addr1.value=streetNumber + sep + route;
        });
    }

    function setupOnChangeListner(inputField) {
        inputField.addEventListener("change", function () {

            var $addr1 = document.querySelector("#" + inputField.id + "AddressFields_AddressLine1"),
                $city = document.querySelector("#" + inputField.id + "AddressFields_City"),
                $state = document.querySelector("#" + inputField.id + "AddressFields_State"),
                $zip = document.querySelector("#" + inputField.id + "AddressFields_ZipCode"),
                $country = document.querySelector("#" + inputField.id + "AddressFields_Country");

            //console.log("address 1", $addr1.value);
            //Clear all fields first so it removes previously selected address.
            $addr1.value="";
            $city.value="";
            $state.value="";
            $zip.value="";
            $country.value="";
        });
    }
}